// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import './BlogLinkCard.css';

const BlogLinkCard = ({ url, text }) => {
    const [blogData, setBlogData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchBlogData = async () => {
            try {
                // Extract slug from URL
                // Assuming URL format: .../blog/posts/some-slug or just some-slug
                let slug = '';
                try {
                    const urlObj = new URL(url);
                    const pathSegments = urlObj.pathname.split('/').filter(Boolean);
                    // Standard path: /blog/posts/:slug
                    if (pathSegments.includes('posts')) {
                        slug = pathSegments[pathSegments.indexOf('posts') + 1];
                    } else {
                        // Fallback: take the last segment
                        slug = pathSegments[pathSegments.length - 1];
                    }
                } catch (e) {
                    // If url is not a valid URL string, maybe it's just the slug?
                    slug = url;
                }

                if (!slug) {
                    throw new Error('Could not extract slug');
                }

                const response = await axios.get(API_ENDPOINTS.BLOG.POST_BY_SLUG(slug));
                if (response.data) {
                    setBlogData(response.data);
                }
            } catch (err) {
                console.error("Error fetching blog data for card:", err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        if (url) {
            fetchBlogData();
        }
    }, [url]);

    if (loading) return <span className="blog-link-loading inline-block px-2 py-0.5 bg-gray-100 rounded-full text-[0.75rem] text-gray-500 align-middle">Loading link...</span>;
    if (error || !blogData) return <a href={url} target="_blank" rel="noopener noreferrer" className="blog-link-fallback text-[#47b5ff] underline font-medium">{text || url}</a>;

    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className="blog-link-card inline-flex items-center bg-[#47b5ff] rounded-lg px-2 py-0.5 text-white no-underline my-0 mx-1 max-w-full transition-all duration-200 gap-1.5 border border-white border-opacity-40 h-[30px] whitespace-nowrap relative hover:translate-y-[-2px] sm:h-[24px] sm:px-1.5 sm:py-0.25 md:h-[24px] md:px-1.5 md:py-0.25" style={{
            boxShadow: '0 0 0 1px rgba(71, 181, 255, 0.3), 0 2px 6px rgba(71, 181, 255, 0.2)',
            top: '-1px'
        }} onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 0 0 2px rgba(71, 181, 255, 0.4), 0 3px 8px rgba(71, 181, 255, 0.3)'; }} onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 0 0 1px rgba(71, 181, 255, 0.3), 0 2px 6px rgba(71, 181, 255, 0.2)'; }}>
            <span className="blog-link-thumbnail flex-shrink-0 w-[20px] h-[20px] rounded-[20%] overflow-hidden bg-white bg-opacity-20 flex items-center justify-center ml-0.5 border border-white border-opacity-60 sm:w-[18px] sm:h-[18px] md:w-[18px] md:h-[18px]">
                {blogData.coverImage && blogData.coverImage.url ? (
                    <img src={blogData.coverImage.url} alt={blogData.title} className="w-full h-full object-cover block" />
                ) : (
                    <span className="blog-link-placeholder-img text-white text-[0.8rem] flex">
                        <i className="fi fi-sr-journal-alt"></i>
                    </span>
                )}
            </span>
            <span className="blog-link-content inline-flex flex-row items-center leading-none pr-0">
                <span className="blog-link-label hidden">
                    Read more on Blog #{blogData.postNumber}
                </span>
                <span className="blog-link-title text-[0.8rem] font-bold font-[Roboto_Flex,Inter,-apple-system,BlinkMacSystemFont,Segoe_UI,Roboto,Helvetica,Arial,sans-serif] whitespace-nowrap overflow-hidden text-ellipsis max-w-[150px] tracking-wider leading-[1.25] pb-0.5 sm:max-w-[100px] md:max-w-[100px]">
                    {text || blogData.title}
                </span>
            </span>
            <span className="blog-link-icon hidden">
                <i className="fi fi-rr-arrow-up-right"></i>
            </span>
        </a>
    );
};

export default BlogLinkCard;
